export namespace FareReviewTriggerResultNameConstants {
  export const ALL_TYPE: string = 'All Type';
  export const TOLLS: string = 'Tolls';
  export const DISTANCE: string = 'Distance';
  export const DURATION: string = 'Duration';
  export const CLIENT_INVOICE_AMOUNT: string = 'Client invoice amount';
  export const PROVIDER_INVOICE_AMOUNT: string = 'Provider invoice amount';
}
